// Public exports for the layouts module

export { LayoutPage } from './components/LayoutPage/LayoutPage';
export type { LayoutPageProps } from './components/LayoutPage/LayoutPage';
export { WorkflowsPage } from './components/WorkflowsPage/WorkflowsPage';
export { AdminLayoutsPage } from './components/AdminLayouts/AdminLayoutsPage';
export * from './types';

// Admin hub registration card for this module
import type { AdminCard } from '../../admin/types';

export const layoutAdminCard: AdminCard = {
  title: 'Layout Configuration',
  description:
    'Manage the sidebar categories and item ordering for the Workflows and Docs layout pages.',
  subCards: [
    {
      title: 'Docs Layout',
      description: 'Configure categories and documents for the Docs page.',
      to: '/oneadvanced-admin/layouts/docs',
    },
    {
      title: 'Workflow Layout',
      description: 'Configure categories and templates for the Workflows page.',
      to: '/oneadvanced-admin/layouts/workflows',
    },
  ],
};
